import { RouterRoutesSettings } from "app/tools/router/types";

export const useVariableExpenseRoutes = (): RouterRoutesSettings => {
  return {
    authenticatedOnly: [
      {
        children: [
          {
            HydrateFallback: () => null,
            index: true,
            lazy: async () => {
              const { VariableExpensePageList } = await import("./pageList");
              return { Component: VariableExpensePageList };
            },
            path: ":year?/:month?",
          },
          {
            HydrateFallback: () => null,
            lazy: async () => {
              const { VariableExpensePageAdd } = await import("./pageAdd");
              return { Component: VariableExpensePageAdd };
            },
            path: "add",
          },
          {
            HydrateFallback: () => null,
            lazy: async () => {
              const { VariableExpensePageEdit } = await import("./pageEdit");
              return { Component: VariableExpensePageEdit };
            },
            path: "edit/:id",
          },
        ],
        path: "variable-expenses",
      },
    ],
  };
};
